export enum Periodicity {
  None = 'Aucune periodicité',
  Monthly = 'Mensuelle',
  Bimonthly = 'Bimestrielle',
  Biannual = 'Semestrielle',
  Annual = 'Annuelle',
  StartAndEnd = 'Début et fin de mission'
}
